var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('h1',[_vm._v("404 Page Missing")]),_c('article',[_c('p',[_vm._v("This page displays when a route is accessed that doesn't exist.")])])])
}]

export { render, staticRenderFns }